export default "__VITE_ASSET__B3R$wYGf__"